<template>
    <div id="administrator-dashboard">
        <b-overlay :show="showLoading" spinner-variant="primary">

            <b-card no-body>

                <b-card-body>
                    <section id="dashboard-admin" :key="showDataKeys">
                        <b-row class="match-height">
                            <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>{{ culumnChartNumbersTitle }}</h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts type="line" height="400" :options="columnChartNumbers.chartOptions"
                                        :series="columnChartNumbers.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                        </b-row>
                    </section>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import {
    kFormatter
} from '@core/utils/filter'
import {
    $themeColors
} from "@themeConfig";
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        VueApexCharts,
    },
    data() {
        return {
            culumnChartNumbersTitle: "Variation Quotidienne des Ventes Par Nombre de Commandes",
            columnChartNumbers: {
                series: [{
                    name: 'Nombre Total',
                    data: []
                },],
                chartOptions: {
                    colors: [$themeColors.primary, $themeColors.secondary],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        width: 5,
                        curve: 'smooth',
                        show: true,
                    },

                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return kFormatter(value);
                            }
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                            }
                        }
                    }
                }
            },
            showDataKeys: 0,
            showLoading: true,
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
        }
    },
    methods: {
        async loadData() {
            this.columnChartNumbers.series[0].data = [];
            this.columnChartNumbers.chartOptions.xaxis.categories = [];
            this.showLoading = true;
            let response = await this.$http.get("navendpoints/getOrdersList" + "?dateDebut= " + this.startDate + "&dateFin=" + this.endDate).catch(() => {
                this.showLoading = false;
            });
            this.culumnChartNumbersTitle = "Variation Quotidienne des Ventes Par Nombre de Commandes";
            const output = this.processOrdersGroupedByDays(response.data.value);
            this.columnChartNumbers.chartOptions.xaxis.categories = output.dataGroupedByDays.map(obj => obj.day);
            this.columnChartNumbers.series[0].data = output.dataGroupedByDays.map(obj => obj.orderCount);
            this.showDataKeys += 1;
            this.showLoading = false;
        },
        processOrdersGroupedByDays(inputList) {
            const orders = [];

            // Step 1: Extract and parse the data
            inputList.forEach(item => {
                const postingDate = item.Posting_Date;
                const amount = parseFloat(item.Amount_Including_VAT);
                const orderNo = item.No;

                orders.push({ postingDate, amount, orderNo });
            });

            // Step 2: Group data by day and calculate sum of amount per day
            const groupedByDay = {};
            orders.forEach(order => {
                const { postingDate, amount } = order;
                if (!groupedByDay[postingDate]) {
                    groupedByDay[postingDate] = { sumAmount: 0, orderCount: 0 };
                }
                groupedByDay[postingDate].sumAmount += amount;
                groupedByDay[postingDate].orderCount++;
            });

            // Step 3: Prepare the final output with "DD Month" format
            const dataGroupedByDays = Object.keys(groupedByDay).map(day => {
                const formattedDay = new Date(day).toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short'
                });

                return {
                    day: formattedDay,
                    sumAmount: groupedByDay[day].sumAmount,
                    orderCount: groupedByDay[day].orderCount
                };
            });

            return {
                dataGroupedByDays,
            };
        },
        getCurrentAndPastDay(days) {
            const currentDate = new Date();
            const pastDate = new Date();
            pastDate.setDate(pastDate.getDate() - days);

            const formattedCurrentDay = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1 + "").padStart(2, "0")}-${currentDate.getDate()}`;
            const formattedPastDay = `${pastDate.getFullYear()}-${(pastDate.getMonth() + 1 + "").padStart(2, "0")}-${pastDate.getDate()}`;

            return {
                currentDay: formattedCurrentDay,
                pastDay: formattedPastDay,
            };
        },
    },
    created() {
        let data = this.getCurrentAndPastDay(20);
        this.startDate = data.pastDay;
        this.endDate = data.currentDay;
        this.loadData();
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>